import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MobileNavigationVerticalAccordion
from '@cotyorg/ccx-organism-navigation/components/MobileNavigationVertical/MobileNavigationVerticalAccordion';

const generateFooterAccordionClassNames = extraClassNames => classNames(
  'navigation',
  'footer-accordion',
  extraClassNames,
);

const FooterAccordion = ({
  children,
  footer: { pages } = {},
  extraClass,
  openAccordionButtonExtraClass,
  accordionBodyExtraClass,
  minusIconSrc,
  plusIconSrc,
  navigationLinkIconWidth,
  navigationLinkIconHeight,
}) => (
  <div className={generateFooterAccordionClassNames(extraClass)}>
    <nav>
      <div>
        <MobileNavigationVerticalAccordion
          pages={pages}
          openAccordionButtonExtraClass={openAccordionButtonExtraClass}
          accordionBodyExtraClass={accordionBodyExtraClass}
          minusIconSrc={minusIconSrc}
          plusIconSrc={plusIconSrc}
          navigationLinkIconWidth={navigationLinkIconWidth}
          navigationLinkIconHeight={navigationLinkIconHeight}
        />
        {children}
      </div>
    </nav>
  </div>
);

FooterAccordion.propTypes = {
  footer: PropTypes.shape({
    pages: PropTypes.array.isRequired,
  }).isRequired,
  children: PropTypes.node,
  extraClass: PropTypes.string,
  openAccordionButtonExtraClass: PropTypes.string,
  accordionBodyExtraClass: PropTypes.string,
  minusIconSrc: PropTypes.string,
  plusIconSrc: PropTypes.string,
  navigationLinkIconWidth: PropTypes.number,
  navigationLinkIconHeight: PropTypes.number,
};

export default FooterAccordion;
